import {padNum, texture} from "p3";
import definitions from "../../../definitions";
import Enemy from "./Enemy";

export default class EnemySpikeTrap extends Enemy {
    constructor() {
        super(definitions.ENEMY_ID.SPIKE_TRAP);

        this.zSort = false;

        this.moveSpeed = 0;

        this.collisionEnabled = false;
        this.collisionDynamic = false;

        this._attackTime = 0;
        this._attackDelay = 1;
        this._attackOffset = 0;
        this._isAttacking = false;
    }

    init() {
        super.init();

        let frames = [];
        for (let i = 0; i < 1; ++i) {
            frames[i] = texture("spike_trap_" + padNum(i, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "idle");

        frames = [];
        for (let i = 0; i < 6; ++i) {
            frames[i] = texture("spike_trap_" + padNum(i, 2));
        }
        frames.push(texture("spike_trap_" + padNum(0, 2)));
        sequence.addTextures(frames, "attack");

        this.addViewWithMovieClip(sequence, "idle");

        this.state = definitions.ENEMY_STATE.ATTACK;

        this._attackTime = -this.attackOffset;
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
        this._view.animationSpeed = 24;
        this._view.gotoAndPlay("idle", true);

        this._view.addFrameScript(1, () => this.onAttackDamage(), null, "attack");
    }

    /**
     * @private
     */
    _startAttack() {
        if (!this._isAttacking) {
            this._attackTime = -this.attackOffset;
            this._isAttacking = true;
            this._view.gotoAndPlay("attack", false);

            this.onAttackFinished();
        }
    }

    /**
     * @return {boolean}
     * @private
     */
    _isTargetInAttackRange() {
        if (this.target) {
            // TODO improve, rects should be supported for actors
            return this.world.testCollisionRectFastOld(
                this.target.collisionX,
                this.target.collisionY,
                this.target.collisionRadius,
                this.x - 48,
                this.y - 110,
                100,
                100,
            );
        }
        return false;
    }

    /**
     * @param {number} state
     * @private
     */
    onStateEnter(state) {
        switch (state) {
            case definitions.ENEMY_STATE.IDLE: {
                this._view.gotoAndPlay("idle", true);
                break;
            }
            case definitions.ENEMY_STATE.ATTACK: {
                break;
            }
        }
    }

    /**
     * @param {number} state
     * @private
     */
    onStateUpdate(state) {
        switch (state) {
            case definitions.ENEMY_STATE.ATTACK: {
                if (!this.isAttacking && this.isAttackReady) {
                    this._startAttack();
                } else {
                    this._attackTime += window.dt;
                }
                break;
            }
        }
    }

    /**
     * @param {number} state
     * @private
     */
    onStateExit(state) {
        switch (state) {
            case definitions.ENEMY_STATE.ATTACK: {
                this._isAttacking = false;
                break;
            }
            case definitions.ENEMY_STATE.TAKE_DAMAGE: {
                this._isTakingDamage = false;
                break;
            }
        }
    }

    /**
     * @param {number} amount
     * @return {boolean}
     */
    takeDamage(amount) {
        return false;
    }

    onAttackDamage() {
        this._isTargetInAttackRange() && this.signals.attack.dispatch(this, this.target, this.damage);
    }

    onAttackFinished() {
        this._attackTime = 0;
        this._isAttacking = false;
    }

    /**
     * @return {number}
     */
    get attackDelay() {
        return this._attackDelay;
    }

    /**
     * @param {number} value
     */
    set attackDelay(value) {
        this._attackDelay = Math.max(1, value);
    }

    /**
     * @return {number}
     */
    get attackOffset() {
        return this._attackOffset
    }

    /**
     * @param {number} value
     */
    set attackOffset(value) {
        this._attackOffset = Math.max(0, value * 0.5);
    }

    /**
     * @return {boolean}
     */
    get isAttacking() {
        return this._isAttacking;
    }

    /**
     * @return {boolean}
     */
    get isAttackReady() {
        return this._attackTime >= this._attackDelay;
    }
}